import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import AustinsMobileSpaOnWheels from "./sections/AustinsMobileSpaOnWheels";
import OurCollectiveMission from "./sections/OurCollectiveMission";
import CuratedCollections from "./sections/CuratedCollections";
import DestaquesDaSemana from "./sections/DestaquesDaSemana";
import TheGardenToVaseJourney from "./sections/TheGardenToVaseJourney";
import ClaimYourStage from "./sections/ClaimYourStage";
import ShopHighlights from "./sections/ShopHighlights";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <AustinsMobileSpaOnWheels />
      <ShopHighlights />
      <OurCollectiveMission />
      <CuratedCollections />
      <DestaquesDaSemana />
      <TheGardenToVaseJourney />
      <ClaimYourStage />
      <Footer />
    </div>;
}